import { XStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { NOTE_ICON, NOTE_TONE, sizingClass, TEXT_STYLE } from '../tokens';

import type { catalog } from '@littlebird/action-cards-view';
import type { ComponentFn } from '@littlebird/action-cards-view/react';

// A tone outside NOTE_TONE's keys (an older client behind a newer catalog) falls back to info
function resolveNoteTone(tone: unknown): keyof typeof NOTE_TONE {
  return typeof tone === 'string' && tone in NOTE_TONE
    ? (tone as keyof typeof NOTE_TONE)
    : 'info';
}

export const Note: ComponentFn<typeof catalog, 'Note'> = ({ props }) => {
  if (!props.text) return null;
  const tone = resolveNoteTone(props.tone);
  const Icon = NOTE_ICON[tone];
  return (
    <XStack
      role="note"
      className={cn(
        'min-w-0 gap-[var(--ac-gap-sm)]',
        tone === 'muted' ? TEXT_STYLE.meta : TEXT_STYLE.note,
        NOTE_TONE[tone].box,
        sizingClass(props.sizing)
      )}
    >
      {Icon ? (
        <span aria-hidden className="mt-[calc(2*var(--ac-u))] shrink-0">
          <Icon className={cn('size-[var(--ac-tile)]', NOTE_TONE[tone].icon)} />
        </span>
      ) : null}
      <span className="min-w-0 flex-1 whitespace-pre-wrap break-words">
        {props.text}
      </span>
    </XStack>
  );
};
